import React, { useEffect } from "react";

import { BaseTile } from "Components/BaseTile";
import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { pageDisplayed } from "Store/analytics/analyticsSlice";
import { FormState } from "Store/priceCalculation/priceCalculationInterfaces";
import { AppPartName } from "Utils/analytics";
import { useScrollToTop } from "Utils/autoScrollUtils";
import { useIsDesktopScreenSize } from "Utils/screenSizeUtils";
import { FormikChildren } from "Utils/types";

interface Props extends FormikChildren {
  readonly onSubmit?: (formValues?: FormState) => void;
  readonly initialValues?: any;
  readonly validationSchema?: any | (() => any);
  readonly header: string;
  readonly maxWidth?: string;
}

export const ProductPriceTile = ({
  children,
  initialValues,
  validationSchema,
  onSubmit,
  header,
  maxWidth,
}: Props): React.ReactElement => {
  const dispatch = useDispatch();
  useScrollToTop();
  useEffect(() => {
    dispatch(pageDisplayed({ pageName: AppPartName.CHECK_PRICE_STEP }));
  }, []);

  const handleSubmit = (formValues: FormState): void => {
    if (onSubmit) {
      onSubmit(formValues);
    }
  };

  const isDesktop = useIsDesktopScreenSize();

  return (
    <BaseTile header={isDesktop ? header : undefined} maxWidth={maxWidth}>
      <Formik
        initialValues={initialValues ?? {}}
        enableReinitialize
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        validateOnMount
      >
        {children}
      </Formik>
    </BaseTile>
  );
};
